import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "onClick"];
var __jsx = React.createElement;
import React from "react";
import { ELSButton } from "components/common/elsevier/Button/Button";
import DeleteIcon from "components/common/elsevier/Icons/DeleteIcon";
import Styles from "./Styles.module.scss";
function DeleteButton(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ELSButton, _extends({}, props, {
    type: "button",
    className: "".concat(Styles.deleteButton, " es-button__secondary ").concat(className !== null && className !== void 0 ? className : ""),
    onClick: onClick
  }), /*#__PURE__*/React.createElement(DeleteIcon, {
    fontSize: "small"
  }));
}
DeleteButton.defaultProps = {
  disabled: false,
  onClick: function onClick() {}
};
export default DeleteButton;